import React, { useEffect } from 'react';
import { INews } from '../../../common/tin-gpt/define-news';
import ImageNotFound from '../../../images/homepage/Image_not_available.png';
import { GoDotFill } from 'react-icons/go';
import './styles.categoryNews.scss';
import HorizontalNews from '../HorizontalNews/HorizontalNews';
import { useNavigate } from 'react-router-dom';
interface Props {
    categoryNews: any[];
}

const CategoryNewsContainer = (props: Props) => {
    const navigate = useNavigate();

    const [dataCategoryNews, setDataCategoryNews] = React.useState<INews[]>(props.categoryNews)

    useEffect(() => {
        const tmp = props.categoryNews.slice(1, 3).map((news, index) => {
            return {
                ...news,
                image: '',
            }
        })
        setDataCategoryNews(tmp)
    }, [props.categoryNews])
    // Hàm thực hiện thay thế ảnh khi ảnh bị lỗi
    const handleImageError = (e: any) => {
        e.target.onerror = null;
        e.target.src = ImageNotFound;
    }

    const checkLength = (text: string) => {
        if (!text) return '';
        if (text.length > 20) {
            return text.substring(0, 20) + '...';
        }
        return text;
    }
    return (
        <div className='category-news-container'>
            <div className='title-category-news'
                onClick={() => {
                    // Xóa hết các ký tự đặt biệt
                    // const tmp = props.categoryNews[0].title.replace(/[/,:?-]/g, '');
                    // const title = tmp.replace(/ /g, '-').toLowerCase();

                    const url = new URL(props.categoryNews[0].link);
                    const text = url.hostname + url.pathname;
                    const id = props.categoryNews[0].id
                    console.log(text);
                    // const tmp = props.newsContent.title.replace(/[/,:?-]/g, '');
                    // const title = tmp.replace(/ /g, '-').toLowerCase();
                    if (props.categoryNews[0].type === 'AI'|| text.includes('watch')) {
                        navigate(`/detail-news/id=${id}`,);
                    }
                    else {
                        navigate(`/detail-news/${text}`);
                    }

                    // Gán giá trị id vào localStorage
                    localStorage.setItem('id', props.categoryNews[0].id);
                    localStorage.setItem('link', props.categoryNews[0].link);

                }}
            >
                {props.categoryNews[0].title}
            </div>
            <div className='content-category-news'>
                {(dataCategoryNews && dataCategoryNews.length) && dataCategoryNews.map((news: any, index) => (
                    <>
                        <div className='category-news-item'>
                            <GoDotFill />
                            <HorizontalNews
                                newsContent={news}
                                newsCategory={''}
                                imageNotShow={true}
                            />
                        </div>
                    </>
                ))}
                {/* <div className='category-news-action'>
                    Xem thêm <span className='number-category-news-action'>{props.categoryNews.length - 3}</span>
                </div> */}
            </div>


            {props.categoryNews[0].imageContents[0] ?
                <div className='image-category-news'>
                    <img
                        className='image-category'
                        src={props.categoryNews[0].imageContents[0].length > 0 ? props.categoryNews[0].imageContents[0][0] : props.categoryNews[0].imageContents[0]}
                        alt=""
                        onError={handleImageError}
                        onClick={() => {
                            // Xóa hết các ký tự đặt biệt

                            const url = new URL(props.categoryNews[0].link);
                            const text = url.hostname + url.pathname;
                            const id = props.categoryNews[0].id
                            console.log(text);

                            if (props.categoryNews[0].type === 'AI'|| text.includes('watch')) {
                                navigate(`/detail-news/id=${id}`,);
                            }
                            else {
                                navigate(`/detail-news/${text}`);
                            }

                            // Gán giá trị id vào localStorage
                            localStorage.setItem('id', props.categoryNews[0].id);
                            localStorage.setItem('link', props.categoryNews[0].link);
                        }}
                    />
                </div>
                :
                <div className='image-category-news'>
                    <img
                        className='image-category'
                        src={ImageNotFound}
                        alt=""
                        onError={handleImageError}
                        onClick={() => {
                            // Xóa hết các ký tự đặt biệt

                            const url = new URL(props.categoryNews[0].link);
                            const text = url.hostname + url.pathname;
                            const id = props.categoryNews[0].id
                            console.log(text);

                            if (props.categoryNews[0].type === 'AI'|| text.includes('watch')) {
                                navigate(`/detail-news/id=${id}`,);
                            }
                            else {
                                navigate(`/detail-news/${text}`);
                            }

                            // Gán giá trị id vào localStorage
                            localStorage.setItem('id', props.categoryNews[0].id);
                            localStorage.setItem('link', props.categoryNews[0].link);
                        }}
                    />
                </div>
            }

        </div>
    )
}



export default CategoryNewsContainer
